import React from 'react';

const Dashboard = (props: {}): JSX.Element => {
  return <h1>{'Dashboard'}</h1>;
};

export default Dashboard;
